import React, { useEffect } from 'react';
import { useParams } from 'react-router';

export const ShareToPatientForward = () => {
  const { id: uri = '' } = useParams();
  useEffect(() => {
    if (uri) {
      window.location.replace(`/share-to-patient/${uri}/preview`);
    }
  }, [uri]);

  return <></>;
};
